export default "__VITE_ASSET__nuPfY0hT__"